import { combineReducers } from 'redux';

import user from './modules/user';
import error from './modules/error';

export default combineReducers({
  user,
  error,
});
